import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { DeliverySettingsResponse, DeliverySettingsSaveRequest } from "../../../../graphql/types"

export const DELIVERY_SETTINGS_SERVICE_SELECTED = "setting/delivery/service/selected"
export const deliverySettingsServiceSelected = (serviceId: Maybe<string>) => ({
    type: DELIVERY_SETTINGS_SERVICE_SELECTED,
    payload: {
        serviceId: serviceId,
    },
})

export const FETCH_DELIVERY_SETTINGS_SUCCESS = "setting/delivery/data/success"
export const fetchDeliverySettingsSuccess = (data: DeliverySettingsResponse) => ({
    type: FETCH_DELIVERY_SETTINGS_SUCCESS,
    payload: {
        data: data,
    },
})

export const DELIVERY_FEE_FORM_SUBMITTED_V2 = "setting/deliveryFee/submitted/v2"
export const deliveryFeeFormSubmittedV2 = (data: DeliverySettingsSaveRequest) => ({
    type: DELIVERY_FEE_FORM_SUBMITTED_V2,
    payload: {
        data: data,
    },
})

export const DELIVERY_FEE_FORM_SUBMITTED_V2_SUCCESS = "setting/deliveryFee/submitted/v2/success"
export const deliveryFeeFormSubmittedV2Success = () => ({
    type: DELIVERY_FEE_FORM_SUBMITTED_V2_SUCCESS,
})

export const UBER_DIRECT_GENERATE_ORGANIZATION_ID_REQUESTED = "setting/delivery/uberDirect/generateId/requested"
export const uberDirectGenerateOrganizationIdRequested = () => ({
    type: UBER_DIRECT_GENERATE_ORGANIZATION_ID_REQUESTED,
})

export const UBER_DIRECT_GENERATE_ORGANIZATION_ID_SUCCESS = "setting/delivery/uberDirect/generateId/success"
export const uberDirectGenerateOrganizationIdSuccess = (id: string) => ({
    type: UBER_DIRECT_GENERATE_ORGANIZATION_ID_SUCCESS,
    payload: {
        id: id,
    },
})

export const UBER_DIRECT_GENERATE_ORGANIZATION_ID_FAILURE = "setting/delivery/uberDirect/generateId/failure"
export const uberDirectGenerateOrganizationIdFailure = (error: Maybe<any>) => ({
    type: UBER_DIRECT_GENERATE_ORGANIZATION_ID_FAILURE,
    payload: {
        error: error,
    },
})
